import { getCodelistPropById } from 'utils';

export const getSwitchDescription = (codelist) => (id) => getCodelistPropById(id, codelist, 'shortDescription');

export const generateEmailPermission = (permission) => [
	{
		id: permission[0].id,
		attributes: [
			{
				key: 'emailChange',
				value: ['1'],
			},
		],
	},
];
